export default __webpack_public_path__ + "static/media/ip2X.985d8145.svg";